import { observer } from 'mobx-react';
import { ConfirmingDeactivate } from '../../../Store/Types';
import Row from './Row';

interface Props {
  state: ConfirmingDeactivate;
}

function CheckedInvitations({ state }: Props) {
  return (
    <div className="mb-8">
      <div className="md:max-h-[30vh] md:h-[30vh] sm:max-h-[20vh] sm:h-[20vh] text-sm overflow-y-auto">
        {state.multicheckStore.selected.map((invitation) => (
          <Row resource={invitation} key={invitation.payload.id} />
        ))}
      </div>
    </div>
  );
}

export default observer(CheckedInvitations);
